/**
 * Created by koqiui on 2017-04-09.
 */
import { Utils } from '../../app.base'
import { MsgBox, Vue, Routes } from '../../app.vues';
//
import SwbRetailerLayoutAreaSave from './RetailerLayoutAreaSave'
Vue.regist(SwbRetailerLayoutAreaSave);
//
import SwbRetailerLayoutAreaDetail from './RetailerLayoutAreaDetail'
Vue.regist(SwbRetailerLayoutAreaDetail);
//
import SwbRetailerLayoutAreaDevcList from './RetailerLayoutAreaDevcList'
Vue.regist(SwbRetailerLayoutAreaDevcList);
//
import SwbLayoutAreaTree from './LayoutAreaTree'
Vue.regist(SwbLayoutAreaTree);

// 布放区保存
export function openRetailerLayoutAreaSaveDlg(params, callBack) {
    let id = params["id"] || null;
    let title = Utils.isNoB(id) ? '布放区 - 新增' : '布放区 - 编辑';
    Vue.$showDialog({
        title: title,
        width: 700,
        height: 500,
        showCloseBtn: true,
        okVisible: true,
        template: '<swb-retailer-layout-area-save :item="item" ref="swb_retailer_layout_area_save"></swb-retailer-layout-area-save>',
        data: {
            item: params
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retailer_layout_area_save.getDlgResult() || {};
            if(result.type == 'info') {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

// 布放区详情
export function openRetailerLayoutAreaDetailDlg(id) {
    //
    Vue.$showDialog({
        title: '布放区 - 查看',
        width: 1200,
        height: 600,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-retailer-layout-area-detail :id="id"></swb-retailer-layout-area-detail>' +
        '</div>',
        data: {
            id: id
        },
        okClicked: function () {

        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

// 查看布放区设备
export function openRetailerLayoutAreaDevcListDlg(params, callBack) {
    let id = params["id"] || null;
    let level = params["level"] || null;
    let temperAffectedDevcId = params["temperAffectedDevcId"] || null;
    let bizUnitId = params["bizUnitId"] || null;
    //
    Vue.$showDialog({
        title: '布放区设备 - 查看',
        width: -100,
        height: -160,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-retailer-layout-area-devc-list :bizUnitId="bizUnitId" :layoutAreaId="layoutAreaId" :layoutAreaLevel="layoutAreaLevel" :temperAffectedDevcId="temperAffectedDevcId" ref="swb_retailer_layout_area_devc_list"></swb-retailer-layout-area-devc-list>' +
        '</div>',
        data: {
            layoutAreaId: id,
            layoutAreaLevel: level,
            temperAffectedDevcId: temperAffectedDevcId,
            bizUnitId: bizUnitId
        },
        okClicked: function () {

        },
        cancelClicked: function () {
            let needRefresh = this.$refs.swb_retailer_layout_area_devc_list.getDlgResult();
            callBack(needRefresh);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

// 布放区选择
export function openLayoutAreaTreeSelectDlg(dlgConfig = {}, callback) {
    //
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let enableSearch = dlgConfig['enableSearch'];
    let isClickEvent = dlgConfig['isClickEvent'];
    let isRadio = dlgConfig['isRadio'];
    let bizUnitId = dlgConfig['bizUnitId'] || null;
    let initCheckId = dlgConfig['initCheckId'] || null;
    let initCheckIds = dlgConfig['initCheckIds'] || [];
    //
    Vue.$showDialog({
        title: '布放区 - 选择',
        width: 500,
        height: 700,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-layout-area-tree :enableSearch="enableSearch" :isClickEvent="isClickEvent" :isRadio="isRadio" :bizUnitId="bizUnitId" :initCheckId="initCheckId" :initCheckIds="initCheckIds" ref="swb_layout_area_tree_for_select"></swb-layout-area-tree>' +
        '</div>',
        data: {
            enableSearch: enableSearch,
            isClickEvent: isClickEvent,
            isRadio: isRadio,
            bizUnitId: bizUnitId,
            initCheckId: initCheckId,
            initCheckIds: initCheckIds
        },
        okClicked: function () {
            let result = this.$refs.swb_layout_area_tree_for_select.getDlgResult() || {};
            callback(result.data);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/layoutArea/showDlg.js
// module id = 358
// module chunks = 0